<template>
  <div>
    <mf-action-buttons
      v-if="newCampaign && !franchise"
      :primary-button="{
        text: 'Ativar campanha',
        action: saveActive,
        isVisible: true,
        isLoading: loading.saveActive,
        isDisabled: anyLoading && !loading.saveActive,
      }"
      :secondary-button="{
        text: 'Salvar rascunho',
        action: saveDraft,
        isVisible: true,
        isLoading: loading.saveDraft,
        isDisabled: anyLoading && !loading.saveDraft,
      }"
      :cancel-button="{
        text: 'Cancelar',
        action: redirectCampanhas,
        isVisible: true,
      }"
    />

    <mf-action-buttons
      v-else-if="scheduledCampaign && !franchise"
      :primary-button="{
        text: 'Salvar alterações',
        action: saveActive,
        isVisible: true,
        isLoading: loading.saveActive,
        isDisabled: anyLoading && !loading.saveActive,
      }"
      :secondary-button="{
        text: 'Desativar',
        action: disableDraft,
        isVisible: true,
        isLoading: loading.disableDraft,
        isDisabled: anyLoading && !loading.saveDraft,
      }"
      :cancel-button="{
        text: 'Cancelar',
        action: redirectCampanhas,
        isVisible: true,
      }"
    />

    <mf-action-buttons
      v-else-if="finishedCampaign && !franchise"
      :primary-button="{
        text: 'Duplicar',
        action: clone,
        isVisible: true,
        isLoading: loading.clone,
        isDisabled: anyLoading && !loading.clone,
      }"
      :cancel-button="{
        text: 'Cancelar',
        action: redirectCampanhas,
        isVisible: true,
      }"
    />

    <mf-action-buttons
      v-else-if="draftCampaign && !franchise"
      :primary-button="{
        text: 'Ativar campanha',
        action: saveActive,
        isVisible: true,
        isLoading: loading.saveActive,
        isDisabled: anyLoading && !loading.saveActive,
      }"
      :secondary-button="{
        text: 'Salvar alterações',
        action: saveDraft,
        isVisible: true,
        isLoading: loading.saveDraft,
        isDisabled: anyLoading && !loading.saveDraft,
      }"
      :extra-button="{
        text: 'Apagar rascunho',
        action: deleteCampaign,
        isVisible: true,
        isLoading: loading.deleteCampaign,
        isDisabled: anyLoading && !loading.deleteCampaign,
      }"
      :cancel-button="{
        text: 'Cancelar',
        action: redirectCampanhas,
        isVisible: true,
      }"
    />

    <mf-action-buttons
      v-else-if="activeCampaign && !franchise"
      :primary-button="{
        text: 'Salvar alterações',
        action: saveActive,
        isVisible: true,
        isLoading: loading.saveDraft,
        isDisabled: anyLoading && !loading.saveDraft,
      }"
      :secondary-button="{
        text: 'Finalizar',
        action: finalizeCommercial,
        isVisible: true,
        isLoading: loading.saveActive,
        isDisabled: anyLoading && !loading.saveActive,
      }"
      :cancel-button="{
        text: 'Cancelar',
        action: redirectCampanhas,
        isVisible: true,
      }"
    />

    <mf-action-buttons
      v-else-if="franchise"
      :primary-button="{
        text: 'Fechar',
        action: redirectCampanhas,
        isVisible: true,
      }"
    />
  </div>
</template>

<script>
import { MUTATION_UNSCHEDULED_COMMERCIAL, MUTATION_FINALIZE_COMMERCIAL, MUTATION_CLONE_COMMERCIAL, MUTATION_DELETE_COMMERCIAL } from '../../graphql'

export default {
  props: {
    object: Object,
    mode: String,
    save: Function,
    franchise: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loading: {
      saveDraft: false,
      saveActive: false,
      clone: false,
      deleteCampaign: false,
    },
  }),
  computed: {
    newCampaign() {
      return !this.object._id
    },
    activeCampaign() {
      return ['ACTIVE'].includes(this.object.status)
    },
    finishedCampaign() {
      return ['FINISHED'].includes(this.object.status)
    },
    draftCampaign() {
      return ['DRAFT'].includes(this.object.status)
    },
    scheduledCampaign() {
      return ['SCHEDULED'].includes(this.object.status)
    },
    anyLoading() {
      return Object.entries(this.loading).some(([key, value]) => value)
    },
  },
  methods: {
    async saveDraft() {
      this.loading.saveDraft = true
      try {
        await this.save(true)
      } catch (e) {
        this.$snackbar({ message: 'Ocorreu um erro ao salvar campanha.' })
      } finally {
        this.loading.saveDraft = false
      }
    },
    async disableDraft() {
      const confirmed = await this.$confirm({
        title: 'Desativar campanha',
        message: 'Tem certeza que deseja desativar esta campanha?',
        confirmText: 'Desativar',
        confirmColor: 'primary',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return
      this.loading.clone = true
      await this.$apollo
        .mutate({
          mutation: MUTATION_UNSCHEDULED_COMMERCIAL,
          variables: {
            id: this.object._id,
          },
        })
        .then(() => {
          this.redirectCampanhas()
        })
        .catch(() => {
          this.$snackbar(this.$t('campanhas.snackbars.errors.delete'))
        })
      this.loading.clone = false
    },
    async finalizeCommercial() {
      const confirmed = await this.$confirm({
        title: 'Finalizar campanha',
        message: 'Tem certeza que deseja finalizar esta campanha?',
        confirmText: 'Finalizar',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return
      this.loading.clone = true
      await this.$apollo
        .mutate({
          mutation: MUTATION_FINALIZE_COMMERCIAL,
          variables: {
            id: this.object._id,
          },
        })
        .then(() => {
          this.redirectCampanhas()
        })
        .catch(() => {
          this.$snackbar(this.$t('campanhas.snackbars.errors.delete'))
        })
      this.loading.clone = false
    },
    async saveActive() {
      this.loading.saveActive = true
      try {
        await this.save(false)
      } catch (e) {
        this.$snackbar({ message: 'Ocorreu um erro ao salvar campanha.' })
      } finally {
        this.loading.saveActive = false
      }
    },
    async clone() {
      const confirmed = await this.$confirm({
        ...this.$t('campanhas.confirmations.clone'),
        message: `Deseja duplicar ${this.object.title ? 'a campanha ' + this.object.title.trim().bold() : 'esta campanha'}?`,
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return
      this.loading.clone = true
      await this.$apollo
        .mutate({
          mutation: MUTATION_CLONE_COMMERCIAL,
          variables: {
            id: this.object._id,
          },
        })
        .then(
          ({
            data: {
              cloneCommercial: { _id: newId },
            },
          }) => {
            this.redirectCampanhas()
          }
        )
        .catch(() => {
          this.$snackbar(this.$t('campanhas.snackbars.errors.clone'))
        })
      this.loading.clone = false
    },
    async deleteCampaign() {
      const confirmed = await this.$confirm({
        title: 'Remover campanha',
        message: 'Tem certeza que deseja remover esta campanha?',
        confirmText: 'Remover',
        confirmColor: 'vermelho-d20',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return
      this.loading.clone = true
      await this.$apollo
        .mutate({
          mutation: MUTATION_DELETE_COMMERCIAL,
          variables: {
            id: this.object._id,
          },
        })
        .then(() => {
          this.redirectCampanhas()
        })
        .catch(() => {
          this.$snackbar(this.$t('campanhas.snackbars.errors.delete'))
        })
      this.loading.clone = false
    },
    redirectCampanhas() {
      this.$router.push(`/mobile/banners/`).catch(() => {})
    },
  },
}
</script>
